import { combineReducers } from '@reduxjs/toolkit';
import shouldUpdateBigNumbers from './shouldUpdateBigNumbers';

export default combineReducers({
  shouldUpdateBigNumbers,
});
